import { observer } from 'mobx-react-lite';

import { IcBack32Icon, IcDeleteIcon, IcEditIcon, IcForwardArticleIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { IconButton } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.css';

const Header = ({ message, goBack, onDelete }) => {
  const presenter = usePresenter({ message });

  return (
    <>
      <AddKeyPressHandler onEsc={goBack} />
      <div className={styles.container}>
        <IconButton
          Icon={IcBack32Icon}
          onClick={goBack}
        />

        <div className={styles.rightBlock}>
          {presenter.isShowForwardAction && (
            <IconButton
              className={styles.icon}
              Icon={IcForwardArticleIcon}
              onClick={presenter.forward}
            />
          )}

          {presenter.isShowDeleteAction && (
            <IconButton
              className={styles.icon}
              Icon={IcDeleteIcon}
              onClick={onDelete}
            />
          )}

          {presenter.isShowEditAction && (
            <IconButton
              className={styles.icon}
              Icon={IcEditIcon}
              onClick={presenter.edit}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default observer(Header);
